// Commonly used Remix Icon classes for services
export const REMIX_ICONS = [
  { name: 'Shield', icon: 'ri-shield-line' },
  { name: 'Camera', icon: 'ri-camera-line' },
  { name: 'Safe', icon: 'ri-safe-line' },
  { name: 'Tools', icon: 'ri-tools-line' },
  { name: 'Settings', icon: 'ri-settings-3-line' },
  { name: 'Lock', icon: 'ri-lock-line' },
  { name: 'Unlock', icon: 'ri-unlock-line' },
  { name: 'Key', icon: 'ri-key-line' },
  { name: 'Eye', icon: 'ri-eye-line' },
  { name: 'Eye Off', icon: 'ri-eye-off-line' },
  { name: 'Search', icon: 'ri-search-line' },
  { name: 'Shield Check', icon: 'ri-shield-check-line' },
  { name: 'Shield Alert', icon: 'ri-shield-alert-line' },
  { name: 'Server', icon: 'ri-server-line' },
  { name: 'Cloud', icon: 'ri-cloud-line' },
  { name: 'Database', icon: 'ri-database-2-line' },
  { name: 'Network', icon: 'ri-wifi-line' },
  { name: 'Smartphone', icon: 'ri-smartphone-line' },
  { name: 'Computer', icon: 'ri-computer-line' },
  { name: 'Router', icon: 'ri-router-line' },
  { name: 'Building', icon: 'ri-building-line' },
  { name: 'Home', icon: 'ri-home-line' },
  { name: 'Building 2', icon: 'ri-building-2-line' },
  { name: 'Factory', icon: 'ri-factory-line' },
  { name: 'Plant', icon: 'ri-plant-line' },
  { name: 'Briefcase', icon: 'ri-briefcase-line' },
  { name: 'Team', icon: 'ri-team-line' },
  { name: 'User', icon: 'ri-user-line' },
  { name: 'Users', icon: 'ri-group-line' },
  { name: 'Bar Chart', icon: 'ri-bar-chart-line' },
  { name: 'Pie Chart', icon: 'ri-pie-chart-line' },
  { name: 'Line Chart', icon: 'ri-line-chart-line' },
  { name: 'Check', icon: 'ri-check-line' },
  { name: 'Close', icon: 'ri-close-line' },
  { name: 'Alert', icon: 'ri-alert-line' },
  { name: 'Information', icon: 'ri-information-line' },
  { name: 'Help', icon: 'ri-question-line' },
  { name: 'Star', icon: 'ri-star-line' },
  { name: 'Heart', icon: 'ri-heart-line' },
  { name: 'Thumb Up', icon: 'ri-thumb-up-line' },
  { name: 'Bookmark', icon: 'ri-bookmark-line' },
  { name: 'Tag', icon: 'ri-price-tag-line' },
  { name: 'Lightbulb', icon: 'ri-lightbulb-line' },
  { name: 'Flash', icon: 'ri-flashlight-line' },
  { name: 'Zap', icon: 'ri-flashlight-line' },
  { name: 'Cpu', icon: 'ri-cpu-line' },
  { name: 'Code', icon: 'ri-code-line' },
  { name: 'Settings 2', icon: 'ri-settings-line' },
  { name: 'Sliders', icon: 'ri-slider-line' },
  { name: 'Plug', icon: 'ri-plug-line' },
  { name: 'Headphones', icon: 'ri-headphone-line' },
  { name: 'Phone', icon: 'ri-phone-line' },
  { name: 'Mail', icon: 'ri-mail-line' },
  { name: 'Chat', icon: 'ri-chat-3-line' },
  { name: 'Message', icon: 'ri-message-line' },
  { name: 'Bell', icon: 'ri-notification-line' },
  { name: 'Calendar', icon: 'ri-calendar-line' },
  { name: 'Time', icon: 'ri-time-line' },
  { name: 'Clock', icon: 'ri-clock-line' },
  { name: 'Watch', icon: 'ri-watch-line' },
  { name: 'Document', icon: 'ri-file-line' },
  { name: 'PDF', icon: 'ri-file-pdf-line' },
  { name: 'Image', icon: 'ri-image-line' },
  { name: 'Gallery', icon: 'ri-gallery-line' },
  { name: 'Folder', icon: 'ri-folder-line' },
  { name: 'Download', icon: 'ri-download-line' },
  { name: 'Upload', icon: 'ri-upload-line' },
  { name: 'Link', icon: 'ri-links-line' },
  { name: 'Share', icon: 'ri-share-line' },
  { name: 'Share 2', icon: 'ri-share-2-line' },
  { name: 'Export', icon: 'ri-export-right-line' },
  { name: 'Import', icon: 'ri-import-right-line' },
  { name: 'Refresh', icon: 'ri-refresh-line' },
  { name: 'Reload', icon: 'ri-reload-line' },
  { name: 'Sync', icon: 'ri-refresh-2-line' },
  { name: 'History', icon: 'ri-history-line' },
  { name: 'Undo', icon: 'ri-arrow-go-back-line' },
  { name: 'Redo', icon: 'ri-arrow-go-forward-line' },
  { name: 'Copy', icon: 'ri-file-copy-line' },
  { name: 'Scissors', icon: 'ri-scissors-line' },
  { name: 'Trash', icon: 'ri-delete-bin-line' },
  { name: 'Add', icon: 'ri-add-line' },
  { name: 'Subtract', icon: 'ri-subtract-line' },
  { name: 'Plus', icon: 'ri-add-fill' },
  { name: 'Minus', icon: 'ri-subtract-fill' },
  { name: 'Arrow Right', icon: 'ri-arrow-right-line' },
  { name: 'Arrow Left', icon: 'ri-arrow-left-line' },
  { name: 'Arrow Up', icon: 'ri-arrow-up-line' },
  { name: 'Arrow Down', icon: 'ri-arrow-down-line' },
  { name: 'Chevron Right', icon: 'ri-chevron-right-line' },
  { name: 'Chevron Left', icon: 'ri-chevron-left-line' },
  { name: 'Chevron Up', icon: 'ri-chevron-up-line' },
  { name: 'Chevron Down', icon: 'ri-chevron-down-line' },
  { name: 'Menu', icon: 'ri-menu-line' },
  { name: 'More', icon: 'ri-more-2-line' },
  { name: 'More Vertical', icon: 'ri-more-line' },
  { name: 'Dashboard', icon: 'ri-dashboard-line' },
  { name: 'Map', icon: 'ri-map-line' },
  { name: 'Location', icon: 'ri-map-pin-line' },
  { name: 'Navigation', icon: 'ri-navigation-line' },
  { name: 'Compass', icon: 'ri-compass-line' },
];
